import { useContext } from 'react';
import { CRYPTO_WALLET_TYPE } from '../../constants';
import { UserContext } from '../../context';

export const useCryptoWallets = (targetCurrency = '') => {
  const [user] = useContext(UserContext);
  const { userOptions = {}, feWallets = [] } = user;
  const { walletCurrency } = userOptions;
  const currency = targetCurrency || walletCurrency;

  const realUserWallets = feWallets.filter(
    (wallet) => wallet.accountName === CRYPTO_WALLET_TYPE.REAL
  );

  const baseBalance =
    feWallets.find(
      (wallet) =>
        wallet.accountName === CRYPTO_WALLET_TYPE.REAL &&
        wallet.currency === currency
    )?.balance || 0;

  const bonusBalance =
    feWallets.find(
      (wallet) =>
        wallet.accountName === CRYPTO_WALLET_TYPE.PRE_WAGER_BONUS &&
        wallet.currency === currency
    )?.balance || 0;

  return {
    baseBalance,
    bonusBalance,
    realUserWallets
  };
};
